// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

//Backend access
import moment from "moment";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";


function CameraSelects({ startTime, setStartTime, endTime, setEndTime }) {

    const header = (
        <SoftBox display={'flex'}>
            <SoftBox mb={1} >
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker value={startTime} maxDate={endTime.clone().subtract(1, 'hour')} onChange={(new_value) => { setStartTime(new_value) }} />
                    {/* <TimePicker value={startTime} maxTime={endTime.clone().subtract(1, 'hour')} onChange={(new_value) => { setStartTime(new_value) }} /> */}
                </LocalizationProvider>
            </SoftBox>
            <SoftBox mb={1} pl={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker value={endTime} minDate={startTime.clone().add(1, 'hour')} onChange={(new_value) => { setEndTime(new_value) }} />
                    {/* <TimePicker value={endTime} minTime={startTime.clone().add(1, 'hour')} onChange={(new_value) => { setEndTime(new_value) }} /> */}
                </LocalizationProvider>
            </SoftBox>
        </SoftBox >
    );

    return header;

}

// Typechecking props for the CameraSelects
CameraSelects.propTypes = {
    startTime: PropTypes.instanceOf(moment()),
    setStartTime: PropTypes.func,
    endTime: PropTypes.instanceOf(moment()),
    setEndTime: PropTypes.func
};

export default CameraSelects;

